import { css } from 'styled-components';

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var get = function get(path, object) {
  if (Object.prototype.hasOwnProperty.call(object, path)) {
    return object[path];
  } // eslint-disable-next-line @typescript-eslint/no-explicit-any


  var result = object;
  var segments = path.split('.');

  var _iterator = _createForOfIteratorHelper(segments),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _segment = _step.value;

      if (!Object.prototype.hasOwnProperty.call(result, _segment)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("Path \"".concat(path, "\" not found on object."));
        }

        return undefined;
      }

      result = result[_segment];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
};

var queries = {
  mobile: '(min-width: 0em)',
  tablet: '(min-width: 46.0625em)',
  // 737px
  desktop: '(min-width: 64.0625em)' // 1025px

};

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        @media ", " {\n          ", "\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function getQuery(media, queries) {
  if (process.env.NODE_ENV !== 'production') {
    if (!Object.prototype.hasOwnProperty.call(queries, media)) {
      console.warn("Media \"".concat(media, "\" not found in queries."));
    }
  }

  return queries[media];
}
/**
 * Create a mixin that applies styles when a media query is matched
 * @param options
 */


var createMatch = function createMatch(queriesOrGetQueries) {
  return function (media) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (first) {
      var query = typeof queriesOrGetQueries === 'function' ? function (_ref) {
        var theme = _ref.theme;
        return getQuery(media, queriesOrGetQueries(theme));
      } : getQuery(media, queriesOrGetQueries);

      for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return css(_templateObject(), query, css.apply(void 0, [first].concat(interpolations)));
    };
  };
};

var match = createMatch(function (theme) {
  var _ref;

  // using any because unless the consumer defines the `media` property on the
  // theme the property will not exist and will result in compilation errors
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var media = (_ref = theme) === null || _ref === void 0 ? void 0 : _ref.media;

  if (media) {
    return media;
  }

  return queries;
});

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _createForOfIteratorHelper$1(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 *
 * Create a mixin that maps a value to styles for each media query
 *
 * @param match
 */
var createMap = function createMap(match) {
  return function (valueOrValues, fn) {
    // handle a singular value (non-responsive)
    if (_typeof(valueOrValues) !== 'object') {
      return fn(valueOrValues);
    } // handle a map of values (responsive)


    var styles = [];

    var _iterator = _createForOfIteratorHelper$1(Object.keys(valueOrValues)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var media = _step.value;

        // ensure the property is not inherited
        if (!Object.prototype.hasOwnProperty.call(valueOrValues, media)) {
          continue;
        }

        var value = valueOrValues[media]; // Casting `value` should be safe here because .hasOwnProperty should ensure
        // the value has been set and the types should ensure the value is not
        // undefined

        var style = fn(value); // eslint-disable-next-line @typescript-eslint/no-explicit-any

        styles.push(match(media)({}, style)); // FIXME: remove casting
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return styles;
  };
};

var map = createMap(match);

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n        ", ": ", ";\n      "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

function _createForOfIteratorHelper$2(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function createStylesFromTransformedValue(properties, value) {
  var styles = [];

  var _iterator = _createForOfIteratorHelper$2(properties),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      styles.push(css(_templateObject$1(), property, value));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return styles;
} // eslint-disable-next-line @typescript-eslint/no-explicit-any


/**
 * Creates a responsive mixin for a set of properties
 * @param properties The CSS property names
 * @param transform  The transformation function
 *
 * @example
 * const marginLeft = createMixin(['margin-left', 'margin-right'], value => `${value}px`)(0);
 * const marginLeft = createMixin(['margin-left', 'margin-right'], value => ({theme}) => `${theme.space[value]}px`)(0);
 * marginLeft(1);
 * marginLeft({mobile: 1, desktop: 2});
 *
 */
var createMixin = function createMixin(_ref) {
  var map = _ref.map,
      properties = _ref.properties,
      transform = _ref.transform;
  return function (valueOrValues) {
    return map(valueOrValues, function (value) {
      return createStylesFromTransformedValue(properties, transform(value));
    });
  };
};

/**
 * Create a mixin that maps props to mixins
 *
 * @param mixins The mixins
 * @returns A mixin
 *
 * @example
 * const Box = styled.div(
 *  createProps({
 *    paddingX,
 *    paddingY
 *  })
 * );
 */
var createProps = function createProps(mixins) {
  return function (props) {
    var styles = [];

    var _loop = function _loop() {
      var name = _Object$keys[_i];
      var mixin = mixins[name];
      var prop = props[name];

      if (mixin === undefined || prop === undefined) {
        return "continue";
      }

      if (Array.isArray(mixin)) {
        mixin.forEach(function (m) {
          return styles.push(m(prop));
        });
      } else {
        styles.push(mixin(prop));
      }
    };

    for (var _i = 0, _Object$keys = Object.keys(props); _i < _Object$keys.length; _i++) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }

    return styles;
  };
};

/**
 * Create a mixin that returns styles for a specific selection.
 *
 * A variant may consist of responsive styles but it is not responsive itself
 * because emotion/styled-components would need to support nested media queries.
 * If you require a responsive variant, try rolling your own with a switch
 * statement in a map function.
 *
 * @param variants The style variants
 * @returns A mixin
 *
 * @example
 * const variant = createVariant({
 *   primary: {
 *     color: 'blue'
 *   },
 *   secondary: {
 *     color: 'black'
 *   },
 *   secondary: {
 *     color: 'grey'
 *   }
 * });
 * const Box = styled.div(
 *   {},
 *   variant('primary')
 * )
 *
 */
var createVariant = function createVariant(variants) {
  return function (variant) {
    var style = variants[variant];

    if (process.env.NODE_ENV !== 'production') {
      if (!Object.prototype.hasOwnProperty.call(variants, variant)) {
        console.warn("Variant \"".concat(variant, "\" was not found."));
      }
    }

    return style;
  };
};

/**
 * Map a value to another value
 * @experimental
 * @param input
 * @param fn
 */
// eslint-disable-next-line @typescript-eslint/camelcase
function unstable_mapValueToValue(input, fn) {
  if (input === undefined) {
    return undefined;
  }

  if (_typeof(input) !== 'object') {
    return fn(input);
  }

  var result = {};

  for (var media in input) {
    var _value = input[media];

    if (_value !== undefined) {
      result[media] = fn(_value);
    }
  }

  return result;
}

export { createMap, createMatch, createMixin, createProps, createVariant, get, map, match, queries, unstable_mapValueToValue };
//# sourceMappingURL=style.esm.js.map
